import { render, staticRenderFns } from "./PscDeficiencyCompanyInstruction.vue?vue&type=template&id=3fffaef4&scoped=true&"
import script from "./PscDeficiencyCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyCompanyInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fffaef4",
  null
  
)

export default component.exports